import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { requestStudentVerification } from '../services/authService';

const StudentVerification = () => {
    const { currentUser, idToken } = useAuth();
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        if (!idToken) {
            setError('You must be logged in to request verification.');
            return;
        }

        try {
            const response = await requestStudentVerification(email, idToken);
            setMessage(response.message);
        } catch (err) {
            setError(err.message || 'An error occurred while sending the verification email.');
        }
    };

    if (currentUser && currentUser.is_verified_student) {
        return (
            <div>
                <h3>Student Verification</h3>
                <p>🎓 You are already a verified student!</p>
            </div>
        );
    }

    return (
        <div>
            <h3>Get Verified as a Student</h3>
            <p>Submit your academic email to unlock review posting.</p>
            <form onSubmit={handleSubmit}>
                <input
                    type="email"
                    placeholder="Enter your student email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <button type="submit">Send Verification Email</button>
            </form>
            {message && <p style={{ color: 'green' }}>{message}</p>}
            {error && <p style={{ color: 'red' }}>{error}</p>}
            
            <div style={{ marginTop: '30px', paddingTop: '20px', borderTop: '1px solid #e9ecef' }}>
                <p style={{ fontSize: '14px', color: '#666', marginBottom: '15px' }}>
                    Can't verify with your email? Send us proof of student status at:
                </p>
                <a 
                    href="mailto:wodecki.sg@gmail.com?subject=Student Verification Request&body=Hi Rasmoose Team,%0D%0A%0D%0AI would like to request student verification.%0D%0A%0D%0AUsername: [Your username]%0D%0A%0D%0APlease find attached proof of my student status.%0D%0A%0D%0AThank you!"
                    style={{
                        display: 'inline-block',
                        padding: '6px 12px',
                        backgroundColor: 'transparent',
                        color: '#4CAF50',
                        textDecoration: 'none',
                        borderRadius: '3px',
                        fontSize: '13px',
                        border: '1px solid #4CAF50',
                        transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#4CAF50';
                        e.target.style.color = 'white';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'transparent';
                        e.target.style.color = '#4CAF50';
                    }}
                >
                    Send Verification Request
                </a>
            </div>
        </div>
    );
};

export default StudentVerification;
